// @flow
import Href from "../models/href/Href";

import type Locales from "../i18n/Locales";

/**
 */
const encodeQueryString = (queryString: string) => {
  if (!queryString) return "";

  // Create a URLSearchParams object from the existing query string
  // It handles all the splitting, decoding, and special characters automatically.
  const params = new URLSearchParams(queryString);

  // Return the encoded query string
  // toString() correctly re-encodes everything.
  return params.toString();
};

/**
 */
export const getFullRequestUrl = (request: HttpServletRequestJava): string => {
  let pathInfo = request.getPathInfo() || "/";
  let queryString = request.getQueryString();

  pathInfo = pathInfo
    .split("/")
    .map((segment) => encodeURIComponent(segment))
    .join("/");

  if (queryString) {
    return `${pathInfo}?${encodeQueryString(queryString)}`;
  }

  return pathInfo;
};

/**
 */
export const getFullRequestHref = (request: HttpServletRequestJava): Href =>
  new Href(getFullRequestUrl(request));

/**
 */
export const getCookieFromRequest = (
  request: HttpServletRequestJava,
  cookieName: string,
): null | string => {
  return request.getCookieByName(cookieName);
};

/**
 */
export const getPreferredLocale = (
  request: HttpServletRequestJava,
  locales: Locales,
): void | string => {
  const languageFromCookie = getCookieFromRequest(request, "locale");
  const acceptLanguageHeader =
    languageFromCookie || request.getHeader("Accept-Language");

  // when no accept language header or cookie present, get first locale code
  if (acceptLanguageHeader === null) {
    return locales.availableLocaleCodes[0];
  }

  return locales.getPreferredLocale(acceptLanguageHeader);
};
